import type { BillingAddressFields } from './types';
import { ADDRESS_FORM_FIELD_NAMES } from '../../../constants';

/** Creates the form payload used to save a billing address. */
export function createBillingAddressFormData(billingType: string, billingFields: BillingAddressFields): FormData {
  const formData = new FormData();
  formData.set(ADDRESS_FORM_FIELD_NAMES.DESTINATION_TYPE, billingType);

  Object.entries(billingFields).forEach(([field, value]) => formData.set(field, String(value ?? '')));

  return formData;
}
